<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editForm" ref="editFormRef" label-width="170px">
          <el-form-item class="addAdminForm" label="托管销售人员">
            <el-select v-model="editForm.salesmanid" placeholder="请选择" class="select" filterable>
              <el-option
                v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="addAdminForm" label="跟单员">
            <el-select v-model="editForm.gendanmanid" placeholder="请选择" class="select" filterable>
              <el-option
                v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="addAdminForm" label="客户名称">
            <el-input v-model="editForm.customername"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="联系方式">
            <el-input v-model="editForm.lianxifangshi"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="银行账号">
            <el-input v-model="editForm.bankaccount"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="开户行">
            <el-input v-model="editForm.bankname"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="备注">
            <el-input v-model="editForm.beizhu"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="最低预存金额">
            <el-input v-model="editForm.amountmin"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      SalesManList:[],
      editForm: {
        id: 0,
        salesmanid: '',
        gendanmanid: '',
        customername: '',
        lianxifangshi: '',
        bankaccount: '',
        bankname: '',
        beizhu: '',
        amountmin: '0'
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row,SalesManList) {
      this.editForm.id = row.Id
      this.editForm.salesmanid = row.Salesmanid
      this.editForm.gendanmanid = row.Gendanmanid
      this.editForm.customername = row.Customername
      this.editForm.lianxifangshi = row.Lianxifangshi
      this.editForm.bankaccount = row.Bankaccount
      this.editForm.bankname = row.Bankname
      this.editForm.beizhu = row.Beizhu
      this.editForm.amountmin = row.Amountmin
      this.SalesManList = SalesManList
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditErp6SaleBaseCustomerInfo()
    },
    apiEditErp6SaleBaseCustomerInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6SaleBaseCustomerInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
